import { render, staticRenderFns } from "./BotaoProtecaoDados.vue?vue&type=template&id=ceaff18c&"
import script from "./BotaoProtecaoDados.vue?vue&type=script&lang=js&"
export * from "./BotaoProtecaoDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports